<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex xs6>
                <h1>Archived Staff</h1>
            </v-flex>
            <v-flex xs6 class="text-right">
                <v-btn color="primary" depressed dark @click="createUserCallback()">Add Staff</v-btn>
                <v-btn color="primary" class="ml-2" outlined :to="'/management/staff'">Active</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="archivedUsers"
                        item-key="name"
                        class="elevation-1">
                        <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="orange"
                                        @click="updateDialogForUser(item)">
                                        mdi-square-edit-outline
                                    </v-icon>
                                </template>
                                <span>Edit User</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="green"
                                        @click="restoreDialogForUser(item)">
                                        mdi-backup-restore
                                    </v-icon>
                                </template>
                                <span>Restore User</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        color="primary"
                                        @click="passwordReset(item)">
                                        mdi-lock-reset
                                    </v-icon>
                                </template>
                                <span>Reset Password</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        color="red"
                                        @click="deleteDialogForUser(item)">
                                        delete_forever
                                    </v-icon>
                                </template>
                                <span>Delete Forever</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <add-user
            :showDialog="createUserDialog"
            :toggle="toggleCreate">
        </add-user>
        <update-user
            :showDialog="updateUserDialog"
            :toggle="toggleUpdate"
            :userDetails="userToUpdate"
            :userRole="userRole">
        </update-user>
        <restore-user
            :showDialog="restoreUserDialog"
            :toggle="toggleArchive"
            :user="userRestore">
        </restore-user>
        <delete-user
            :showDialog="deleteUserDialog"
            :toggle="toggleDelete"
            :user="userToDelete">
        </delete-user>

       <password-reset
            :showDialog="passwordDialog"
            :toggle="togglePassword"
            :user="userToUpdate">
        </password-reset>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import AddUser from '@/components/users/Add'
    import UpdateUser from '@/components/users/Update'
    import RestoreUser from '@/components/users/Restore'
    import DeleteUser from '@/components/users/Delete'
    import PasswordReset from '@/components/users/ResetPassword'
    export default {
        name: 'listArchivedStaff',
        components: {
            AddUser,
            UpdateUser,
            RestoreUser,
            DeleteUser,
            PasswordReset
        },
        created () {
            this.loadArchivedUsers()
            this.loadRoles()
        },
        data () {
            return {

                restoreUserDialog: false,
                updateUserDialog: false,
                createUserDialog: false,
                deleteUserDialog: false,
                passwordDialog: false,
                userRestore: null,
                userToDelete: null,
                userRole: null,
                index: null,
                userToUpdate: {},
            }
        },


                methods: {
                    ...mapActions({
                        loadArchivedUsers: 'user/loadArchivedUsers',
                        loadRoles: 'role/loadRoles',
                        clearAccount: 'account/clearAccount'
                    }),
                    createUserCallback() {
                        this.createUserDialog = true;
                    },
                    toggleCreate () {
                        this.createUserDialog = !(this.createUserDialog)
                    },
                    toggleUpdate () {
                        this.updateUserDialog = !(this.updateUserDialog)
                    },
                    toggleArchive () {
                        this.restoreUserDialog = !(this.restoreUserDialog)
                    },
                    toggleDelete () {
                        this.deleteUserDialog = !(this.deleteUserDialog)
                    },
                    togglePassword () {
                        this.passwordDialog = !(this.passwordDialog)
                    },
                    restoreDialogForUser (item) {
                        this.userRestore = item.user
                        this.toggleArchive()
                    },
                    updateDialogForUser (item) {
                        this.userToUpdate = item.user
                        this.userRole = item.user.roles[0]
                        this.toggleUpdate()
                    },
                    deleteDialogForUser (item) {
                        this.userToDelete = item.user
                        this.toggleDelete()
                    },
                    passwordReset (item) {
                        this.userToUpdate = item.user
                        this.clearAccount()
                        item.user.password = ''
                        item.user.confirm = ''
                        this.togglePassword()
                    }
                },
                computed: {
                    ...mapGetters({
                        archivedUsers: 'user/archived',
                        users: 'user/users',
                        headers: 'user/headers',
                        error: 'user/error'
                    })
                }
            }

</script>
